import React from 'react';
import './colorBlur.css'

function ColorBlur() {
  return (
    <>
      <div className='color-blur-1'></div>
      <div className='color-blur-2'></div>
    </>
  );
}


export default ColorBlur;